import { compose, map, path, pathOr } from 'ramda'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { MIC_ACCESS_ERROR } from '@/app/definitions'
import { selectToken } from '@/app/module/auth/store/selectors'
import { getCustomFields } from '@/app/module/custom-fields/store/actions'
import { getFilesItem } from '@/app/module/files/store/actions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId, selectUserId, selectUserTimezone } from '@/app/module/user/store/selectors'
import config from '@/config'

import Logs from './component'
import {
  clearFilters,
  downloadCalls,
  downloadMessages,
  downloadTopups,
  downloadWhatsapp,
  getCalls,
  getMessages,
  getTopups,
  getWhatsapp,
  navigateLogs,
  reloadCalls,
  reloadMessages,
  reloadTopups,
  reloadWhatsapp,
  saveWhatsappFile,
  sendWhatsappMessage,
  setMessagesPageSize,
} from './store/actions'
import { selectPersonalizationList } from './store/selectors'

const pageSizeDefault = path(['modules', 'messages', 'pageSize', 'default'], config)
const pageSizeValues = compose(
  map((val) => ({ name: val, value: val })),
  path(['modules', 'messages', 'pageSize', 'values']),
)(config)

const selector = ({ user, logs, customFields, utils }) => ({
  error: logs.error,
  messages: pathOr('', ['data', 'messages'], logs),
  calls: pathOr('', ['data', 'calls'], logs),
  whatsapp: pathOr('', ['data', 'whatsapp'], logs),
  topups: pathOr('', ['data', 'topups'], logs),
  token: selectToken(),
  orgId: selectOrgId({ user }),
  personalizationList: selectPersonalizationList({ customFields }),
  userId: selectUserId({ user }),
  totalCount: pathOr(0, ['data', 'totalCount'], logs),
  pageSize: pathOr(pageSizeDefault, ['data', 'pageSize'], logs),
  endCursor: pathOr('', ['data', 'pageInfo', 'endCursor'], logs),
  hasNextPage: pathOr('', ['data', 'pageInfo', 'hasNextPage'], logs),
  pageSizeValues,
  timezone: selectUserTimezone({ user, utils }),
})

const dispatcher = (dispatch) =>
  bindActionCreators(
    {
      setPageSize: setMessagesPageSize,
      getMessages,
      getCalls,
      getWhatsapp,
      getTopups,
      reloadMessages,
      reloadCalls,
      reloadWhatsapp,
      reloadTopups,
      downloadMessages,
      downloadCalls,
      downloadWhatsapp,
      downloadTopups,
      navigateLogs,
      getFilesItem,
      getCustomFields,
      sendWhatsappMessage,
      clearFilters,
      saveWhatsappFile,
      onMicAccessError: () =>
        dispatch(
          createNotification({
            'mic-access': {
              type: 'error',
              message: MIC_ACCESS_ERROR,
            },
          }),
        ),
    },
    dispatch,
  )

export default connect(selector, dispatcher)(withRouter(Logs))
